import { DtoExt } from '@/classes/scenario/DtoExt';
import { ScenarioRenFrWind } from '@/dto/scenario/ren-fr/wind/ScenarioRenFrWind';

export class ScenarioRenFrWindExt extends DtoExt {

  public static fromDto(dto: ScenarioRenFrWind): ScenarioRenFrWindExt {
    return new ScenarioRenFrWindExt({
      numberOfTurbineType1: dto.numberOfTurbineType1,
      turbineModelType1: dto.turbineModelType1,
      unitPowerOfTurbineType1: dto.unitPowerOfTurbineType1,
      rotorDiameterType1: dto.rotorDiameterType1,
      numberOfTurbineType2: dto.numberOfTurbineType2,
      turbineModelType2: dto.turbineModelType2,
      unitPowerOfTurbineType2: dto.unitPowerOfTurbineType2,
      rotorDiameterType2: dto.rotorDiameterType2,
      net_p50: dto.net_p50,
      net_p90: dto.net_p90,
      numberOfPdl: dto.numberOfPdl,
      numberOfPdlPtr: dto.numberOfPdlPtr,
      numberOfPtr: dto.numberOfPtr
    });
  }

  public numberOfTurbineType1: number | null = null;
  public turbineModelType1: string | null = null;
  public unitPowerOfTurbineType1: number | null = null;
  public rotorDiameterType1: number | null = null;
  public numberOfTurbineType2: number | null = null;
  public turbineModelType2: string | null = null;
  public unitPowerOfTurbineType2: number | null = null;
  public rotorDiameterType2: number | null = null;

  public net_p50: number | null = null;
  public net_p90: number | null = null;

  public numberOfPdl: number | null = null;
  public numberOfPdlPtr: number | null = null;
  public numberOfPtr: number | null = null;

  constructor(options?: Partial<ScenarioRenFrWindExt> | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
    }
  }

  public toDto(): ScenarioRenFrWind {
    return new ScenarioRenFrWind({
      numberOfTurbineType1: this.numberOfTurbineType1,
      turbineModelType1: this.turbineModelType1,
      unitPowerOfTurbineType1: this.unitPowerOfTurbineType1,
      rotorDiameterType1: this.rotorDiameterType1,
      numberOfTurbineType2: this.numberOfTurbineType2,
      turbineModelType2: this.turbineModelType2,
      unitPowerOfTurbineType2: this.unitPowerOfTurbineType2,
      rotorDiameterType2: this.rotorDiameterType2,
      net_p50: this.net_p50,
      net_p90: this.net_p90,
      numberOfPdl: this.numberOfPdl,
      numberOfPdlPtr: this.numberOfPdlPtr,
      numberOfPtr: this.numberOfPtr
    });
  }
}
